import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createActionCost',
    serviceName: 'labadmin',
    query: gql`
      mutation createActionCost(
        $lab_id: String!
        $action_id: String!
        $price: String!
        $is_active: Int # 0 , >1
        $details: String
      ) {
        createActionCost(
          lab_id: $lab_id
          action_id: $action_id
          price: $price
          is_active: $is_active
          details: $details
        ) {
          model {
            id
            price
          }
          messages
        }
      }
    `,
  },
};

export default schema;
